import produce, { Draft } from 'immer';

import { AccountInfo, GetAccountInfoAction } from '../actions/accountInfo';

const initialBuildsState: AccountInfo = {
  timezone: 'UTC',
  hasSampleLevelDocuments: false,
  reportNumberPrefix: '',
};

export const accountInfoReducer = produce(
  (state: Draft<AccountInfo>, action: GetAccountInfoAction) => {
    if (action.type === 'GOT_ACCOUNT_INFO') {
      state.timezone = action.payload.timezone;
      state.hasSampleLevelDocuments = action.payload.hasSampleLevelDocuments;
      state.reportNumberPrefix = action.payload.reportNumberPrefix;
    }
  },
  initialBuildsState
);
